<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
      >
        <h3>Histórico de mudança de status</h3>
        <div>
          <span class="m-quick-sidebar__close mt-2" @click="closeThis()">
            <i class="fal fa-times-circle fa-lg"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <div class="container-table">
        <table
          class="table table-striped- table-bordered table-hover table-checkable"
        >
          <thead>
            <tr>
              <th class="text-center td-class">Data</th>
              <th class="text-center td-class">Usuário</th>
              <th class="text-center td-class">Status</th>
              <th class="text-center td-class">Motivo</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-if="loading" class="text-center" colspan="5">
                <output class="spinner-border" aria-live="polite">
                  <span class="sr-only">Loading...</span>
                </output>
              </td>
            </tr>
            <tr v-for="(history, id) in data" :key="id">
              <td class="text-center">
                {{ history.created_at | datetime }}
              </td>
              <td class="text-center">
                {{ history.user.name }}
              </td>
              <td
                class="text-center font-weight-bold"
                :class="'status-' + history.status"
              >
                {{ history.status == 1 ? 'Ativo' : 'Bloqueado' }}
              </td>
              <td class="text-center wrap-text">
                {{ history.change_reason }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'PendingInvoiceStatusHistory',
  computed: {
    showLogError() {
      return this.$store.state.showLogError;
    },
    showLogPendingInvoices() {
      return this.$store.state.showLogPendingInvoices;
    },
  },
  data() {
    return {
      data: [],
      loading: true,
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    callData() {
      this.data = [];
      this.loading = true;
      this.getDatas();
    },
    getDatas() {
      const pending = this.$store.state.showLogPendingInvoices;
      const url = `${baseApiUrl}/v1/invoice/pending/history/${pending.id}`;
      axios(url)
        .then((res) => {
          this.data = res.data;
          this.loading = false;
        })
        .catch((err) => {
          console.log('erro', err);
          this.loading = false;
        });
    },
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showLogPendingInvoices = null;
      this.$parent.callData();
    },
  },
  mounted() {
    this.getDatas();
  },
};
</script>
<style scoped>
.status-queued {
  color: #ffc94f;
}
.status-finished {
  color: #00d86b;
}
.status-processing {
  color: #7592ff;
}
.status-error {
  color: #ff7575;
}
.td-class {
  white-space: nowrap;
  width: 100px;
}
.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
}
</style>
